module.exports = __webpack_public_path__ + "static/media/coins-desktop.1f908ff5.svg";